import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Volume2, VolumeX } from "lucide-react";
import { useContent, imgUrl } from "@/lib/content";
import { endIntro, introSeen, startIntro } from "@/lib/intro";

const pickSrc = (intro) => {
  const phone = window.matchMedia("(max-width: 767px)").matches;
  return phone ? intro.media_mobile : intro.media_desktop;
};

const IntroPlayer = ({ src, onDone }) => {
  const video = useRef(null);
  const [muted, setMuted] = useState(true);
  useEffect(() => { video.current?.play().catch(onDone); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (e) => {
    e.stopPropagation();
    video.current.muted = !muted;
    setMuted(!muted);
  };
  const skip = (e) => { e.stopPropagation(); onDone(); };
  return (
    <>
      <video ref={video} className="intro-video" src={imgUrl(src)} muted playsInline autoPlay preload="auto"
        onEnded={onDone} onError={onDone} data-testid="intro-video" />
      <button type="button" className="intro-btn intro-sound" onClick={toggle} aria-label={muted ? "Unmute" : "Mute"} data-testid="intro-unmute-button">
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}<span>{muted ? "Tap for sound" : "Sound on"}</span>
      </button>
      <button type="button" className="intro-btn intro-skip" onClick={skip} data-testid="intro-skip-button">Skip</button>
    </>
  );
};

export const IntroVideo = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data, isLoading } = useContent();
  const [state, setState] = useState(() => (pathname === "/" && !introSeen() ? "on" : "off"));
  const intro = data?.intro;
  const src = intro?.enabled ? pickSrc(intro) : "";

  if (state === "on") startIntro();
  useEffect(() => {
    if (state === "on" && !isLoading && !src) { endIntro(); setState("off"); }
  }, [state, isLoading, src]);

  if (state === "off") return null;
  const done = () => {
    if (state !== "on") return;
    endIntro();
    if (window.location.pathname !== "/") navigate("/");
    setState("fading");
    setTimeout(() => setState("off"), 700);
  };
  return (
    <div className={`intro ${state === "fading" ? "is-fading" : ""}`} onClick={done} role="dialog" aria-label="Welcome video" data-testid="intro-overlay">
      {src && <IntroPlayer src={src} onDone={done} />}
    </div>
  );
};
